<div class="pacientes-page">
  <div class="top">
    <mat-form-field appearance="outline" class="search-box">
      <mat-label>Buscar paciente</mat-label>

      <input
        #buscador
        matInput
        type="text"
        placeholder="Nombre del paciente"
        [(ngModel)]="busqueda"
        (input)="filtrarPacientes()"
        (keydown.escape)="limpiarBusqueda(buscador)"
      />

      @if (busqueda) {
        <button
          mat-icon-button
          matSuffix
          type="button"
          aria-label="Limpiar búsqueda"
          (click)="limpiarBusqueda(buscador)"
        >
          <mat-icon>close</mat-icon>
        </button>
      } @else {
        <mat-icon matSuffix>search</mat-icon>
      }
    </mat-form-field>
  </div>

  <div class="tabla-container">
    <table mat-table [dataSource]="pacientes" class="tabla-pacientes">
      <ng-container matColumnDef="paciente">
        <th mat-header-cell *matHeaderCellDef class="col-paciente">Pacientes</th>
        <td mat-cell *matCellDef="let p" class="col-paciente">
          {{ p.nombre }} {{ p.apellido }} {{ p.segundoApellido }}
        </td>
      </ng-container>

      <ng-container matColumnDef="estudios">
        <th mat-header-cell *matHeaderCellDef>Estudios</th>
        <td mat-cell *matCellDef="let p">
          <button
            mat-icon-button
            (click)="abrirResumenEstudios(p)"
            matTooltip="Ver resumen de estudios"
          >
            <mat-icon class="material-symbols-outlined">biotech</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="receta">
        <th mat-header-cell *matHeaderCellDef>Consultas</th>
        <td mat-cell *matCellDef="let p">
          <button
            mat-icon-button
            (click)="abrirResumenReceta(p)"
            matTooltip="Ver resumen de consultas anteriores"
          >
            <mat-icon class="material-symbols-outlined">event_note</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnas; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columnas"></tr>
    </table>
  </div>
</div>
